import React from "react";
import { isMobileOnly } from "react-device-detect";
import { siteUrl } from "../../utils/constants";
import { StrapiMedia } from "../../types/strapi";
import Img from "./Img";
import { mediaUrl } from "../../utils/imageUtils";

interface ImagesSequenceProps {
  images?: StrapiMedia[];
}

const getImageUrl = (image?: StrapiMedia): string => {
  if (!image?.formats) {
    return "";
  }
  const formats = image.formats;
  return isMobileOnly
    ? formats?.small?.url || ""
    : formats?.large?.url || formats?.small?.url || "";
};

const ImagesSequence: React.FC<ImagesSequenceProps> = ({ images }) =>
  images?.map((image, index) => {
    const caption = image.caption;
    const imageUrl = mediaUrl(getImageUrl(image));

    return (
      <div key={`imagesSequence${index}`} className="container mb--100">
        <Img url={imageUrl} />
        {caption && <p className="text-center mt_dec--20 mb--80">{caption}</p>}
      </div>
    );
  }) || [];

export default ImagesSequence;
